import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'
import { useSelector } from 'react-redux'

const PageWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-flow: column nowrap;
  text-align: center;
`

const MessageWrapper = styled.div`
  font-weight: 900;
  width: 100%;
  h1,
  h2 {
    line-height: 1.2;
    margin: 0 1rem;
  }

  h2 {
    font-size: 1.625rem;
  }

`

const LogoWrapper = styled.div`
  width: 100%;
  justify-content: flex-start;
  height: 6rem;
  display: flex;

  a {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 2rem;

    img {
      width: auto;
      height: 40%;
    }
  }
`

const FourOhFour = ( props ) => {
  const token = useSelector( ( state ) => {
    return state.token
  })

  return (
    <PageWrapper>
      <MessageWrapper>
        <h1>{'404'}</h1>
        <h2>{'Sorry, that page doesn\'t exist'}</h2>
        <p>Token Id: {token}</p>
      </MessageWrapper>
    </PageWrapper>
  )
}

export default FourOhFour